import script from "./BuildingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingPage.vue?vue&type=script&setup=true&lang=js"

import "./BuildingPage.vue?vue&type=style&index=0&id=7232cf32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7232cf32"]])

export default __exports__